<template lang="pug">
.d-contents
  .d-flex.flex-column.gap-12
    app-button(
      color="redesignPrimaryDarken"
      rounded
      block
      @click="setDialogType(constants.DIALOG_TYPE.link)"
    ) Войти по ссылке
    app-button(
      color="redesignPrimaryDarken"
      rounded
      block
      @click="setDialogType(constants.DIALOG_TYPE.phone)"
    ) Войти по номеру телефона
  app-button(
    rounded
    block
    @click="back"
  ).mt-6 Назад

  template(v-if="isDialogOpen")
    component(
      :is="dialogComponent"
      v-model="isDialogOpen"
      @auth="onAuth"
    )
</template>

<script>
import LinkDialog from './dialogs/LinkDialog.vue';
import PhoneDialog from './dialogs/PhoneDialog.vue';

const DIALOG_TYPE = {
  link: 'link',
  phone: 'phone',
};

const DIALOG_COMPONENT = {
  [DIALOG_TYPE.link]: LinkDialog,
  [DIALOG_TYPE.phone]: PhoneDialog,
};

export default {
  name: 'TelegramTab',
  data() {
    return {
      currentDialogType: null,
      isDialogOpen: false,
    };
  },
  computed: {
    constants() {
      return {
        DIALOG_TYPE,
      };
    },
    dialogComponent() {
      return DIALOG_COMPONENT[this.currentDialogType];
    },
  },
  methods: {
    back() {
      this.isDialogOpen = false;
      this.$emit('tab:back');
    },
    setDialogType(type) {
      this.isDialogOpen = true;
      this.currentDialogType = type;
    },
    onAuth(response) {
      this.$emit('auth', response);
    },
  },
};
</script>
